// extracted by mini-css-extract-plugin
export var container = "_5a-1";
export var editor = "_5a-2";
export var resizable = "_5a-3";
export var wrapper = "_5a-0";